export const Props = () => ({
  //--------------------------------------------------------------------------
  //                    Тип кнопки (primary, secondary, alert)
  //--------------------------------------------------------------------------
  type: {
    type: String,
    default: 'none',
    validator: (value) => {
      const allowedTypes = ['none', 'google', 'telegram'];
      if(allowedTypes.includes(value)){
        return true;
      } else{
        throw new Error(`Параметр 'type' в компоненте SocialButton может содержать только значения: ${allowedTypes.join(', ')}`);
      }
    }
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

  //----------------------------------------------------------------------------
  //                           Tекст кнопки, если есть
  //----------------------------------------------------------------------------
  text: {
    type: String,
    required: false,
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

  //----------------------------------------------------------------------------
  //                              Активна кнопка или нет
  //----------------------------------------------------------------------------
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

  //----------------------------------------------------------------------------
  //                    Адресс перехода по клику, если необходимо
  //----------------------------------------------------------------------------
  link:{
    type: String,
    required: false,
    default: null,
  }
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
});